'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416 from "./presto.-Dashboard-View$$anon$16.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418 from "./presto.-Dashboard-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024 from "./presto.types$-Dashboard-System-Stats$.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem$0024 from "./presto.types$-Site-System$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$15() {
  this.aKt = null;
  this.aKl = null;
  this.aKm = false;
  this.aKu = null;
  this.aKv = false;
  this.aKy = null;
  this.aKr = null;
  this.aKs = false;
  this.aKn = null;
  this.aKo = false;
  this.aKp = null;
  this.aKq = false;
  this.aKw = false;
  this.aKx = false;
  this.aKt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKy = "DashboardSystemStats";
}
export { $c_Lpresto_DashboardView$$anon$15 as $c_Lpresto_DashboardView$$anon$15 };
$p = $c_Lpresto_DashboardView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$15;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$15() {
}
export { $h_Lpresto_DashboardView$$anon$15 as $h_Lpresto_DashboardView$$anon$15 };
$h_Lpresto_DashboardView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aKt;
});
$p.M = (function() {
  if ((!this.aKm)) {
    this.aKl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKm = true;
  }
  return this.aKl;
});
$p.O = (function() {
  if ((!this.aKv)) {
    this.aKu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKv = true;
  }
  return this.aKu;
});
$p.D = (function() {
  return this.aKy;
});
$p.t = (function() {
  if ((!this.aKs)) {
    this.aKr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("system", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKs = true;
  }
  return this.aKr;
});
$p.N = (function() {
  if ((!this.aKo)) {
    this.aKn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dSystem$0024.$m_Lpresto_types$SiteSystem$().iq(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416.$c_Lpresto_DashboardView$$anon$16())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKo = true;
  }
  return this.aKn;
});
$p.Q = (function() {
  if ((!this.aKq)) {
    this.aKp = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418.$c_Lpresto_DashboardView$$anon$18();
    this.aKq = true;
  }
  return this.aKp;
});
$p.v = (function() {
  if ((!this.aKx)) {
    this.aKw = false;
    this.aKx = true;
  }
  return this.aKw;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee79) => ((p) => \u03b4scrutinee79.cHt(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024.$m_Lpresto_types$DashboardSystemStats$())));
});
var $d_Lpresto_DashboardView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$15, "presto.DashboardView$$anon$15", ({
  GP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$15 as $d_Lpresto_DashboardView$$anon$15 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$15.js.map
